import { render } from "./SkyCollapse.vue?vue&type=template&id=32502202"
import script from "./SkyCollapse.vue?vue&type=script&lang=js"
export * from "./SkyCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__